import React from 'react';
import { styled } from 'linaria/react';
import AddToCart from '../../Cart/AddToCart';
import Button from '../../ui/Button';
import ProductLink from '@jetshop/ui/ProductLink';
import Image from '@jetshop/ui/Image';
import Badges from '@jetshop/ui/ProductList/Badges';
import t from '@jetshop/intl';
import { theme } from '../../Theming/Theming';
import { GridPrice } from '../../Price';
import { transparentDataImg } from '@jetshop/ui/Image/Image';

const ProductWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  padding: 0.8rem 0;
  //border-right: 1px solid ${theme.colors.border};
  .related-product-image {
    width: 30%;
    ${theme.only.md} {
      width: 15%;
    }
    ${theme.above.lg} {
      width: 15%;
    }
    .badge-wrapper {
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
  .related-product-detail {
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    ${theme.above.lg} {
      width: 85%;
    }
    .related-product-header {
      width: 100%;
      padding: 0 1rem;
      .short-description{
        max-height: 66px;
        overflow: hidden;
      }
      ${theme.above.xl} {
        width: 70%;
      }
    }
    .related-product-cta {
      width: 100%;
      margin-top: 1rem;
      ${theme.above.xl} {
        width: 30%;
      }
      button {
        width: 100%;
        border-radius: 50px;
      }
    }
  }
`;

export const AddonProduct = ({ product, quickBuy }) => {
  //HAS IMAGES
  const hasImages = product.images && product.images.length > 0;

  //STANDARD PRODUCT IMAGE
  let images = product && product.images;
  return (
    <ProductWrapper product={product} categoryPath={null}>
      <div className="related-product-image">
        <ProductLink product={product}>
          {hasImages ? (
            <Image
              sizes={[200]}
              aspect={'1:1'}
              alt={images[0].alt}
              src={images[0].url}
            >
              <div className="badge-wrapper">
                <Badges badges={product.badges} />
              </div>
            </Image>
          ) : (
            <Image src={transparentDataImg} />
          )}
        </ProductLink>
      </div>
      <div className="related-product-detail">
        <header className="related-product-header">
          <ProductLink product={product}>
            <h4>{product.name}</h4>
          </ProductLink>
          <p className="sub-name">{product.subName}</p>
          <p className="short-description">{product.shortDescription}</p>
          <GridPrice {...product} />
        </header>
        <div className="related-product-cta">
          {quickBuy &&
          !product.hasVariants &&
          product.stockStatus &&
          product.stockStatus.buyable ? (
            <AddToCart
              product={product}
              quantity={1}
              selectedVariation={product}
            >
              {add => (
                <Button
                  css={{ marginTop: '1rem' }}
                  className="buy list"
                  onClick={() => {
                    add();
                  }}
                >
                  {t('Add to')}
                </Button>
              )}
            </AddToCart>
          ) : (
            <ProductLink product={product}>
              <Button className="list">{t('Go to')}</Button>
            </ProductLink>
          )}
        </div>
      </div>
    </ProductWrapper>
  );
};
